import { createSlice } from "@reduxjs/toolkit";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PersonIcon from "@mui/icons-material/Person";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TableBarIcon from "@mui/icons-material/TableBar";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import SearchIcon from "@mui/icons-material/Search";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { routePath } from "../../constants/routePath";

export const BusiReport = [
  {
    label: "Total Counter Sale Report",
    value: "Totalcountersalereport",
    routePath: routePath.TOTALCOUNTERSELLREPORT,
  },
  {
    label: "Item Category Wise Daily Counter Sales",
    value: "ItemCatogery",
    routePath: routePath.ITEMCATEGORY,
  },
  {
    label: "Item Wise Counter Sale Report",
    value: "ItemWiseCounterSaleReport",
    routePath: routePath.ITEMSWISECOUNTERSALEREPORT,
  },
  { label: "Gst Report", value: "GstReport", routePath: routePath.GSTREPORT },
  {
    label: "Raw Material Report ",
    value: "RawMaterialReport",
    routePath: routePath.RAWMATERIALREPORTS,
  },

  {
    label: "Counter Sale Of Selected Item",
    value: "CounterSaleOfSelectedItem",
    routePath: routePath.COUNTERSALEOFSELECTEDITEMS,
  },

  {
    label: "List Of Items/ Services",
    value: "ListOfItemSerivces",
    routePath: routePath.LISTOFITEMSSERVICES,
  },
  {
    label: "Inventory Report",
    value: "InventoryReport",
    routePath: routePath.INVENTORYREPORTS,
  },
  {
    label: "Purchase Report",
    value: "PurchaseReportData",
    routePath: routePath.PURCHASEREPORTS,
  },
  {
    label: "Expense Report",
    value: "ExpenceReport",
    routePath: routePath.EXPENSEREPORTS,
  },
];
const customerReport = [
  {
    label: "Customer Information Report",
    value: "CustomerDetailReport",
    routePath: routePath.CUSTOMERINFOREPORT,
  },
  {
    label: "Customer History Report ",
    value: "CustomerHistoryReport",
    routePath: routePath.CUSTOMERHISTORYREPORT,
  },
  {
    label: "Appointment Report",
    value: "AppoinmentReport",
    routePath: routePath.CUSTOMERAPPOINTMENTREPORT,
  },
];
const employeeReport = [
  {
    label: "Employee Advance Payment Report",
    value: "EmployeeAdvanceReport",
    routePath: routePath.EMPLOYEEADVANCEPAYMENTREPORT,
  },
  {
    label: "Employee Payroll Report",
    value: "EmployeePaymentRole",
    routePath: routePath.EMPLOYEEPAYROLLREPORT,
  },
  {
    label: "Employee Details Report",
    value: "EmploDeReport",
    routePath: routePath.EMPLOYEEDETAILREPORT,
  },
];
const reportsTab = [
  {
    label: "Business Reports",
    value: "br",
    br: true,
  },

  {
    label: "Employee  Reports",
    value: "br",
    br: true,
  },
  {
    label: "Employee Advance Payment Report",
    value: "EmployeeAdvanceReport",
  },
  {
    label: "Employee Payroll Report",
    value: "EmployeePaymentRole",
  },

  { label: "Employee Details Report", value: "EmploDeReport" },
  {
    label: "Customer Reports",
    value: "br",
    br: true,
  },

  { label: "Customer Information Report", value: "CustomerDetailReport" },
  {
    label: "Customer History Report ",
    value: "CustomerHistoryReport",
  },
  { label: "Appoinment Report", value: "AppoinmentReport" },
];
const initialState = {
  loading: false,
  manualNavigation: false,
  activeTab: "appointments",
  searchValue: "",
  snackbar: {
    open: false,
    message: "",
    severity: "success",
    duration: 2000,
  },
  navBarInputFields: {
    location: "",
    bussiness: "",
  },
  drawerShow: true,
  mobileNumner: null,
  billNumber: 0,
  mobileTableDrawer: false,
  apppoinmentUerType: "",
  tableName: null,
  currentDataBillNo: 1,
  userDetail: {},
  actvieBussinessDetails: {},
  customerAppointmentId: 0,
  sideBarMenu: [],
  updateBillData: {},
  changeRoll: "",
  favProduct: [],
  headerMenu: [],
  serviceViceSearch: "rate",
  rateChangeHistoryPayload: {},
  cashCounterSaleSummaryPayload: {},
  detail: {},
  // ...logins
  loginSource: null,
  BussinessSideBar: false,
  customerManagmentDisplay: false,
  billingSide: false,
  analaticDisplay: true,
  businessChooseTab: null,
  barName: "bussinessMangment",
  billerMenuseletec: 0,
  billerMenu: [
    { systemFuctionName: "New Bill", route: routePath.COUNTERSELL },
    { systemFuctionName: "Previous Bill", route: routePath.COUNTERSELL },
  ],
  bussinessMangementMenu: [
    {
      tab: [
        {
          value: "expenses",
          label: "Expenses",
          children: [
            { value: "expense", label: "Expense" },
            { value: "ExpenceChategory", label: "Expense Category" },
          ],
        },

        {
          value: "inventory",
          label: "Inventory",
          children: [
            { value: "stock", label: "Stock" },
            { value: "Purchase", label: "Purchase" },
          ],
        },
      ],
      systemFuctionName: "Expenses",
      route: routePath.EXPENCE,
    },

    {
      tab: [{ value: "PersnalInfo", label: "Personal Information" }],
      systemFuctionName: "Employee Master",
      route: routePath.EMPLOYEEINFO,
    },

    {
      tab: [
        { value: "stock", label: "Stock" },
        { value: "Purchase", label: "Purchase" },
      ],
      systemFuctionName: "Purchase",
      route: routePath.EXPENCE,
    },
    {
      tab: [
        { value: "itemDetail", label: "Service / Product Details" },
        { value: "itemcategory", label: "Service Category" },
      ],
      systemFuctionName: "Items Information",
      route: routePath.ITEMSERVICES,
    },
    {
      // tab: [
      //   { value: "PersnalInfo", label: "Personal Information" },
      //   { value: "EducatoinalDetail", label: "Educational Details" },
      //   { value: "expence", label: "Experience Details" },
      //   { value: "attendance", label: "Employee Attendance" },
      //   { value: "associate", label: "Emplyee Access and Restrictions" },
      // ],
      tab: [
        {
          value: "employeeDetails",
          label: "Employee Details",
          children: [
            { value: "PersnalInfo", label: "Personal Information" },
            { value: "EducatoinalDetail", label: "Educational Details" },
            { value: "expence", label: "Experience Details" },
          ],
        },
        {
          value: "paymentstructure",
          label: "Payment Stucture",
          children: [
            { value: "SalaryComponents", label: "Salary Components" },
            { value: "incentive", label: "Incentive" },
            { value: "otherAllowence", label: "Other Allowance" },
            { value: "Deductions", label: "Deductions" },
          ],
        },
        {
          value: "employeePayroll",
          label: "Employee Payroll",
          children: [
            { value: "AdvancePayment", label: "Advance Payment" },
            { value: "settledandpaidAmount", label: "Percentage Wise" },
            { value: "Salary", label: "Salary Wise" },
          ],
        },
        { value: "attendance", label: "Employee Attendance" },
        { value: "associate", label: "Employee Access and Restrictions" },
      ],

      systemFuctionName: "Assistant Payroll",
      route: routePath.EMPLOYEEINFO,
    },

    {
      tab: [
        { value: "outstandingReport", label: "Outstanding Report" },
        {
          value: "payment Report",
          label: "Payment Receipt",
        },
      ],
      systemFuctionName: "Payment Receipt",
      route: routePath.OUTSTANDINGREPORT,
    },

    // {
    //   systemFuctionName: "Associate Users",
    //   route: routePath.ASSOCIATEDUSERS,
    // },

    // {
    //   tab: [
    //     { value: "AdvancePayment", label: "Advance Payment" },
    //     { value: "settledandpaidAmount", label: "Percentage Wise" },
    //     { value: "Salary", label: "Salary Wise" },
    //   ],
    //   systemFuctionName: "Employee Payroll",
    //   route: routePath.EMPLOYEEPAYROLL,
    // },
    // {
    //   tab: [
    //     { value: "SalaryComponents", label: "Salary Components" },
    //     { value: "incentive", label: "Incentive" },
    //     { value: "otherAllowence", label: "Other Allowance" },

    //     { value: "Deductions", label: "Deductions" },
    //   ],
    //   systemFuctionName: "Payment Structure",
    //   route: routePath.PAYMENTSTRUCT,
    // },

    {
      tab: [
        { value: "VenderRegistration", label: "Vendor Registration" },
        { value: "PurchaseManagment", label: "Purchase Order" },
        { value: "Quotation", label: "Quotation" },
        { value: "TermsAndConditions", label: "Terms and Conditions" },
      ],

      systemFuctionName: "Purchase Management",
      route: routePath.PURCHASEMANAGMENT,
    },

    {
      tab: [
        { value: "candidates", label: "Candidates" },
        { value: "posts", label: "Posts" },
      ],

      systemFuctionName: "Hire Candidates",
      route: routePath.JOBHIRINGPOST,
    },
  ],
  customerChategory: [
    {
      systemFuctionName: "Offers",
      route: routePath.ADDOFFER,
    },
    {
      tab: [
        { value: "Unassigned", label: "Unassigned" },
        { value: "Assigned", label: "Assigned" },
      ],
      systemFuctionName: "Appointment",
      route: routePath.APPOINMENTDASHBOARD,
    },
    {
      systemFuctionName: "Business Information",
      route: routePath.MYBUSSINESS,
    },

    {
      systemFuctionName: "Offers & Discounts",
      route: routePath.SHAREMESSAGECONTAINER,
    },

    {
      tab: [
        { value: "customerhistory", label: "customer history" },
        { value: "customer details", label: "customer details" },
        { value: "customergrouping", label: "Customer Groups" },
      ],
      systemFuctionName: "Customer History",
      route: routePath.CUSTOMERINFORMATION,
    },
    { systemFuctionName: "Bulk Messages", route: routePath.BULTMESSAGE },
    { systemFuctionName: "Bulk Upload", route: routePath.BLUESERIVE },
    {
      tab: [
        { value: "instituteinformation", label: "Institute Information" },
        { value: "course", label: "Course" },
      ],
      systemFuctionName: "My Institute",
      route: routePath.MyInstitute,
    },
    {
      tab: [
        { value: "franchiseinformation", label: "Franchise Information" },
        {
          value: "franchiseRequirement",
          label: "Franchise Requirement",
        },
        { value: "franchiseSupport", label: "Franchise Support" },
        { value: "uploadImage", label: "Upload Image" },
        { value: "enquiries", label: "Enquiries" },
      ],
      systemFuctionName: "My Franchise",
      route: routePath.MyFranchise,
    },
    // {
    //   tab: [
    //     { value: "companyinformation", label: "Company Information" },
    //     {
    //       value: "productdetails",
    //       label: "Product Details",
    //     },
    //   ],
    //   systemFuctionName: "White Lable",
    //   route: routePath.WHITELABELS,
    // },
  ],
  analaticsChuild: {
    BusiReport: [...BusiReport],
    EmpReports: [...employeeReport],
    CustomerReports: [...customerReport],
  },
  analatics: [
    {
      label: "Dashboard",
      systemFuctionName: "Dashboard",
      route: routePath.DASHBOARD,
    },

    {
      tab: [
        {
          label: "Business Reports",
          value: "BusiReport",
        },
        {
          label: "Employee Reports",
          value: "EmpReports",
        },
        {
          label: "Customer Reports",
          value: "CustomerReports",
        },
      ],
      label: " Report",
      systemFuctionName: "Reports",
      route: routePath.REPORTS,
    },
  ],
  settingbar: [
    {
      systemFuctionName: "Dashboard",
      route: routePath.DASHBOARD,
    },
  ],

  // .......................Admin Tabssssssssssssssssssssssssssssssssssssssss
  adminCategory: [
    {
      systemFuctionName: "Advertisement",
      route: routePath.ADVERTISEMENT,
    },
    {
      systemFuctionName: "Offers",
      route: routePath.OFFERS,
    },
  ],
  adverticement: [
    {
      systemFuctionName: "Advertisement",
      route: routePath.ADVERTISEMENT,
    },
    {
      systemFuctionName: "Offers",
      route: routePath.OFFERS,
    },
  ],
  UserProfile: [
    //   {
    //   systemFuctionName: "Advertisement",
    //   route: routePath.ADVERTISEMENT,
    //  },
  ],

  Recharge: [
    //  {
    //   systemFuctionName: "Advertisement",
    //   route: routePath.ADVERTISEMENT,
    //  },
  ],
  Support: [{ systemFuctionName: "Reports", route: routePath.REPORTSTAB }],

  // analatics: [
  //   {
  //     systemFuctionName: "Dashboard",
  //     route: routePath.DASHBOARD,
  //   },

  //   {
  //     tab: [
  //       {
  //         label: "Business Reports",
  //         value: "br",
  //         br: true,
  //       },
  //       { label: "Total counter sale report", value: "Totalcountersalereport" },
  //       {
  //         label: "Item Category wise daily counter sales",
  //         value: "ItemCatogery",
  //       },
  //       {
  //         label: "Item Wise Counter Sale Report",
  //         value: "ItemWiseCounterSaleReport",
  //       },
  //       { label: "Gst Report", value: "GstReport" },
  //       {
  //         label: " Raw Material Report ",
  //         value: "RawMaterialReport",
  //       },
  //       // {
  //       //   label: "Discontinued items / Services list ",
  //       //   value: "DiscountinueditemsServiceslist",
  //       // },
  //       // { label: "Gst Report", value: "GstReport" },

  //       // {
  //       //   label: "Item Category wise daily counter sales",
  //       //   value: "ItemCatogery",
  //       // },
  //       // { label: "Total counter sale report", value: "Totalcountersalereport" },
  //       // {
  //       //   label: "Item Wise Counter Sale Report",
  //       //   value: "ItemWiseCounterSaleReport",
  //       // },
  //       // {
  //       //   label: " Raw Material Report ",
  //       //   value: "RawMaterialReport",
  //       // },
  //       {
  //         label: "Counter sale of selected item",
  //         value: "CounterSaleOfSelectedItem",
  //       },

  //       {
  //         label: "List of items/ Services",
  //         value: "ListOfItemSerivces",
  //       },
  //       {
  //         label: "Inventory report",
  //         value: "InventoryReport",
  //       },
  //       {
  //         label: "Purchase Report",
  //         value: "PurchaseReportData",
  //       },
  //       {
  //         label: "Expense report",
  //         value: "ExpenceReport",
  //       },
  //       // {
  //       //   label: "Inventory report",
  //       //   value: "InventoryReport",
  //       // },
  //       // {
  //       //   label: "Discontinued items / Services list ",
  //       //   value: "DiscountinueditemsServiceslist",
  //       // },
  //       {
  //         label: "Employee  Reports",
  //         value: "br",
  //         br: true,
  //       },
  //       {
  //         label: "Employee Advance Payment Report",
  //         value: "EmployeeAdvanceReport",
  //       },
  //       {
  //         label: "Employee Payroll Report",
  //         value: "EmployeePaymentRole",
  //       },

  //       { label: "Employee Details Report", value: "EmploDeReport" },
  //       {
  //         label: "Customer Reports",
  //         value: "br",
  //         br: true,
  //       },

  //       { label: "Customer Information Report", value: "CustomerDetailReport" },
  //       {
  //         label: "Customer History Report ",
  //         value: "CustomerHistoryReport",
  //       },
  //       { label: "Appoinment Report", value: "AppoinmentReport" },
  //     ],
  //     systemFuctionName: "Reports",
  //     route: routePath.REPORTS,
  //   },
  // ],

  billingsideOption: [
    {
      systemFuctionName: "New Bill",
      route: routePath.DASHBOARD,
    },
    {
      systemFuctionName: "Previous Bill",
      route: routePath.DASHBOARD,
    },
  ],
  urlHeaderMenu: [
    {
      label: "Billing",
      systemFuctionName: "Cash Sale Bill",
      route: routePath.COUNTERSELL,
    },

    {
      label: "Anatics",
      systemFuctionName: "Dashboard",
      route: routePath.DASHBOARD,
    },

    {
      label: "Business Management",
      systemFuctionName: "Business Management",
      route: routePath.DASHBOARD,
    },
    // { systemFuctionName: "Reports", route: routePath.REPORTS },

    {
      label: "Customer Management",
      systemFuctionName: "Customer Management",
      route: routePath.DASHBOARD,
    },
    // {
    //   systemFuctionName: "Admin",
    //   route: routePath.ADVERTISEMENT,
    // },

    // { systemFuctionName: "Bills", route: routePath.COUNTERSELLBILLING },

    // { systemFuctionName: "Purchase", route: routePath.INVENTORY },

    // { systemFuctionName: "Stock", route: routePath.STOCKS },
    // { systemFuctionName: "Purchase", route: routePath.PURCHASE },
  ],

  urlHeaderMenuAdmin: [
    // {
    //   systemFuctionName: "Dashboard",
    //   route: routePath.DASHBOARD,
    // },
    {
      systemFuctionName: "UserProfile",
      route: routePath.USERPROFILEC,
    },
    { systemFuctionName: "Recharge", route: routePath.RECHARGE },

    {
      systemFuctionName: "Advertisement & Offers",
      route: routePath.ADVERTISEMENT,
    },
    // { systemFuctionName: "Reports", route: routePath.REPORTS },

    {
      systemFuctionName: "Support",
      route: routePath.REPORTSTAB,
    },
    // {
    //   systemFuctionName: "Admin",
    //   route: routePath.ADVERTISEMENT,
    // },

    // { systemFuctionName: "Bills", route: routePath.COUNTERSELLBILLING },

    // { systemFuctionName: "Purchase", route: routePath.INVENTORY },

    // { systemFuctionName: "Stock", route: routePath.STOCKS },
    // { systemFuctionName: "Purchase", route: routePath.PURCHASE },
  ],
  urlSideBarMenu: [
    {
      systemFuctionName: "My Profile",
      route: routePath.MYPROFILE,
      icon: <PersonIcon sx={{ color: "primary.main" }} />,
    },
    // {
    //   systemFuctionName: "Business Information",
    //   route: routePath.MYBUSSINESS,
    //   icon: <StorefrontIcon sx={{color: "primary.main"}}/>,
    // },
    // {
    //   systemFuctionName: "Table Master",
    //   route: routePath.TABLEMASTER,
    //   icon: <TableBarIcon sx={{color: "primary.main"}}/>,
    // },
    // {
    //   systemFuctionName: "Table Section",
    //   route: routePath.TABLESECTION,
    //   icon: <TableRestaurantIcon sx={{color: "primary.main"}}/>,
    // },
    // {
    //   systemFuctionName: "KYC Documents",
    //   route: routePath.KYCPROCESS,
    //   icon: <SearchIcon sx={{color: "primary.main"}}/>,
    // },

    // {
    //   systemFuctionName: "Items Categories",
    //   route: routePath.ITEMCATEGORIES,
    //   icon: <DashboardIcon sx={{color: "primary.main"}}/>,
    // },
    {
      systemFuctionName: "Account Recharge",
      route: routePath.SMBACCOUNTREACHARGE,
      icon: <CurrencyRupeeOutlinedIcon sx={{ color: "primary.main" }} />,
    },
    {
      systemFuctionName: "Printer Settings",
      route: routePath.SETTING,
      icon: <SettingsOutlinedIcon sx={{ color: "primary.main" }} />,
    },
    {
      systemFuctionName: "Reset M-PIN",
      route: routePath.RESETMPIN,
      icon: <LockOutlinedIcon sx={{ color: "primary.main" }} />,
    },
    {
      systemFuctionName: "Help and Support",
      route: routePath.HELPSUPPORT,
      icon: <HeadsetMicOutlinedIcon sx={{ color: "primary.main" }} />,
    },
    {
      systemFuctionName: "Share Elegant Prime App",
      icon: <ShareOutlinedIcon sx={{ color: "primary.main" }} />,
    },
    // {
    //   systemFuctionName: "Sign Out",
    //   route: null,
    //   icon: <LogoutOutlinedIcon sx={{color: "primary.main"}}/>,
    // },
  ],
};

const reducer = createSlice({
  name: "reducer",
  initialState,
  reducers: {
    setBillNo: (state, action) => {
      state.billNumber = action.payload;
    },
    setUpdateBillData: (state, action) => {
      state.updateBillData = action.payload;
    },
    setSideBarMenu: (state, action) => {
      state.sideBarMenu = action.payload;
    },
    setUserDetail: (state, action) => {
      state.userDetail = action.payload;
    },
    setActvieBussinessDetails: (state, action) => {
      state.actvieBussinessDetails = action.payload;
    },
    setHeaderMenu: (state, action) => {
      state.headerMenu = action.payload;
    },
    startLoading: (state, action) => {
      state.loading = true;
    },
    stopLoading: (state, action) => {
      state.loading = false;
    },
    setTableName: (state, action) => {
      state.tableName = action.payload;
    },
    setDrawerShow: (state, action) => {
      state.drawerShow = action.payload;
    },
    setSnackbar: (state, action) => {
      state.snackbar = action.payload;
    },
    setMobileTableDrawer: (state, action) => {
      state.mobileTableDrawer = action.payload;
    },
    setServiceViceSearch: (state, action) => {
      state.serviceViceSearch = action.payload;
    },
    setRateChangeHistoryPayload: (state, action) => {
      state.rateChangeHistoryPayload = action.payload;
    },

    setCashCounterSaleSummaryPayload: (state, action) => {
      state.cashCounterSaleSummaryPayload = action.payload;
    },
    setNavBarInputFields: (state, action) => {
      state.navBarInputFields = {
        ...state.navBarInputFields,
        ...action.payload,
      };
    },
    setAppoinmentType: (state, action) => {
      state.apppoinmentUerType = action.payload;
    },
    setCustomerAppointmentId: (state, action) => {
      state.customerAppointmentId = action.payload;
    },
    // setfavProduct: (state, action) => {
    //   state.favProduct = action.payload;
    // },
    // removeFavProduct: (state, action) => {
    //   state.favProduct = state.favProduct.filter(
    //     (product) => product.billerId !== action.payload
    //   );
    // },

    setfavProduct: (state, action) => {
      if (
        !state.favProduct.some(
          (item) => item.billerId === action.payload.billerId,
        )
      ) {
        state.favProduct.push(action.payload);
      }
    },
    removeFavProduct: (state, action) => {
      state.favProduct = state.favProduct.filter(
        (product) => product.billerId !== action.payload,
      );
    },

    setDetail: (state, action) => {
      state.detail = action.payload;
    },
    setBarSide: (state, action) => {
      state.billingSide = action.payload;
    },
    setCustomerManagmentDisplay: (state, action) => {
      state.customerManagmentDisplay = action.payload;
    },

    setBussinessSideBar: (state, action) => {
      state.BussinessSideBar = action.payload;
    },
    setchangeRoll: (state, action) => {
      state.changeRoll = action.payload;
    },
    setbusinessChooseTab: (state, action) => {
      state.businessChooseTab = action.payload;
    },
    setAnalaticDisplay: (state, action) => {
      state.analaticDisplay = action.payload;
    },
    setbillerMenuseletected: (state, action) => {
      state.billerMenuseletec = action.payload;
    },
    setBarName: (state, action) => {
      state.barName = action.payload;
    },
    setMobile: (state, action) => {
      state.mobileNumner = action.payload;
    },
    // .logins
    setLoginSource: (state, action) => {
      state.loginSource = action.payload;
    },
    clearLoginSource: (state) => {
      state.loginSource = null;
    },
    setManualNavigation: (state, action) => {
      state.manualNavigation = action.payload;
    },
    setProfileTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    resetProfileTab: () => ({
      activeTab: "",
    }),
  },
});

export const {
  setProfileTab,
  setSearchValue,
  resetProfileTab,
  setUserDetail,
  setMobile,
  startLoading,
  setAnalaticDisplay,
  stopLoading,
  setBillNo,
  setchangeRoll,
  setCustomerManagmentDisplay,
  setHeaderMenu,
  setSideBarMenu,
  setTableName,
  setDrawerShow,
  setUpdateBillData,
  setSnackbar,
  setMobileTableDrawer,
  setServiceViceSearch,
  setNavBarInputFields,
  setRateChangeHistoryPayload,
  setCashCounterSaleSummaryPayload,
  setDetail,
  setAppoinmentType,
  setCustomerAppointmentId,
  setfavProduct,
  removeFavProduct,
  setbusinessChooseTab,
  setBussinessSideBar,
  setActvieBussinessDetails,
  setBarSide,
  setbillerMenuseletected,
  setBarName,
  setLoginSource,
  clearLoginSource,
  setManualNavigation,
} = reducer.actions;

export default reducer.reducer;
